import { render, staticRenderFns } from "./PayNew.vue?vue&type=template&id=876ccb4e&scoped=true"
import script from "./PayNew.vue?vue&type=script&lang=js"
export * from "./PayNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876ccb4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\business\\yoyotravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('876ccb4e')) {
      api.createRecord('876ccb4e', component.options)
    } else {
      api.reload('876ccb4e', component.options)
    }
    module.hot.accept("./PayNew.vue?vue&type=template&id=876ccb4e&scoped=true", function () {
      api.rerender('876ccb4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/products/PayNew.vue"
export default component.exports